<template>
  <Modal
    :show.sync="isOpen"
    :on-close="onClose"
    :modal-main-container-class="'callLogDetailModal'"
    modal-type="right-aligned"
  >
    <div v-if="callLog" class="report_container">
      <aside class="px_4">
        <div class="report_heading mb_24">
          <h2 class="font_regular font_600 text_20">
            {{
              $t('CAMPAIGN.OUTBOUND_CALL_CAMPAIGN.CALL_LOGS.DETAIL_MODAL_TITLE')
            }}
          </h2>
        </div>

        <div class="mb_24">
          <woot-tabs :index="selectedTabIndex" @change="onClickTabChange">
            <woot-tabs-item
              v-for="tab in tabs"
              :key="tab.key"
              :name="tab.name"
              :show-badge="false"
            />
          </woot-tabs>
        </div>

        <section v-if="selectedTabIndex === 0" class="pr_4">
          <p class="text_12 font_700 font_regular">
            {{ $t('CAMPAIGN.LLM_CHATBOT.SINGLE_REPORT_MODAL.DETAILS.SUMMARY') }}
          </p>
          <p class="text_12 font_500 font_regular">
            {{ callLog.summary || '-' }}
          </p>
          <div class="flex_between border_y pt_10 pb_6 mt_20">
            <div>
              <p class="text_12 font_700 font_regular">
                {{
                  $t(
                    'CAMPAIGN.LLM_CHATBOT.SINGLE_REPORT_MODAL.DETAILS.CALL_STATUS'
                  )
                }}
              </p>
            </div>
            <div>
              <span
                v-for="(result, index) in callLog.results"
                :key="index"
                style="
                  display: inline-block;
                  padding: 2px 6px;
                  border-radius: 12px;
                  font-size: 12px;
                  font-weight: 500;
                  margin-right: 4px;
                  margin-bottom: 4px;
                "
                :style="{
                  backgroundColor: getOutcomeColor(result.toLowerCase()).bg,
                  color: getOutcomeColor(result.toLowerCase()).text,
                }"
              >
                {{ result.toUpperCase() }}
              </span>
            </div>
          </div>
        </section>

        <section v-if="selectedTabIndex === 1" class="pr_4">
          <p class="text_12 font_700 font_regular">
            {{
              $t(
                'CAMPAIGN.LLM_CHATBOT.SINGLE_REPORT_MODAL.DETAILS.CLIENT_DATA.LABEL'
              )
            }}
          </p>
          <ul class="data_list">
            <li
              v-if="callLog.contact"
              class="text_12 font_500 font_regular my_10 py_8"
            >
              <p>
                {{
                  $t(
                    'CAMPAIGN.LLM_CHATBOT.SINGLE_REPORT_MODAL.DETAILS.CLIENT_DATA.LIST.NAME'
                  )
                }}
              </p>
              <p>{{ callLog.contact.name }}</p>
            </li>
            <li
              v-if="callLog.contact"
              class="text_12 font_500 font_regular my_10 pb_8"
            >
              <p>
                {{
                  $t(
                    'CAMPAIGN.LLM_CHATBOT.SINGLE_REPORT_MODAL.DETAILS.CLIENT_DATA.LIST.PHONE'
                  )
                }}
              </p>
              <p>{{ callLog.contact.phone_number }}</p>
            </li>
            <li
              v-if="callLog.contact"
              class="text_12 font_500 font_regular my_10 pb_8"
            >
              <p>
                {{
                  $t(
                    'CAMPAIGN.LLM_CHATBOT.SINGLE_REPORT_MODAL.DETAILS.CLIENT_DATA.LIST.EMAIL'
                  )
                }}
              </p>
              <p>{{ callLog.contact.email }}</p>
            </li>
          </ul>
        </section>
      </aside>

      <aside class="right_side px_4">
        <div class="mb_24">
          <h2 class="font_regular font_600 text_20">
            {{ $t('CAMPAIGN.LLM_CHATBOT.SINGLE_REPORT_MODAL.META_TITLE') }}
          </h2>
        </div>
        <ul>
          <li class="text_12 font_500 font_regular">
            <p>
              {{ $t('CAMPAIGN.LLM_CHATBOT.SINGLE_REPORT_MODAL.DETAILS.DATE') }}
            </p>
            <p>{{ getDate(callLog.created_at) }}</p>
          </li>
          <li class="text_12 font_500 font_regular mt_10">
            <p>
              {{
                $t('CAMPAIGN.LLM_CHATBOT.SINGLE_REPORT_MODAL.DETAILS.DURATION')
              }}
            </p>
            <p>{{ formatSecondsToMinSec(callLog.duration) }}</p>
          </li>
        </ul>
      </aside>
    </div>

    <div v-if="isLoading"></div>

    <empty-state v-if="!isLoading && !callLog" :title="'No record found!'" />
    <div v-if="isLoading" class="campaign--loader mt_50">
      <spinner />
      <span>{{ $t('COUPON.COUPON_LIST.LOADING') }}</span>
    </div>
  </Modal>
</template>

<script>
import Modal from 'dashboard/components/Modal.vue';
import moment from 'moment';
import Spinner from 'shared/components/Spinner.vue';
import EmptyState from 'dashboard/components/widgets/EmptyState.vue';

export default {
  name: 'CallLogDetailModal',
  components: {
    Modal,
    Spinner,
    EmptyState,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    callLog: {
      type: Object,
      default: () => ({}),
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedTabIndex: 0,
    };
  },
  computed: {
    tabs() {
      const allTabs = [
        {
          key: 0,
          name: this.$t(
            'CAMPAIGN.LLM_CHATBOT.SINGLE_REPORT_MODAL.TABS.OVERVIEW'
          ),
        },
        {
          key: 1,
          name: this.$t(
            'CAMPAIGN.LLM_CHATBOT.SINGLE_REPORT_MODAL.TABS.CLIENT_DATA'
          ),
        },
      ];

      return allTabs;
    },
  },
  methods: {
    onClose() {
      this.$emit('onClose');
    },
    getDate(date) {
      return moment(date).format('MMM D, h:mm A');
    },
    formatSecondsToMinSec(seconds) {
      const mins = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
    },
    onClickTabChange(index) {
      this.selectedTabIndex = index;
    },
    getOutcomeColor(outcomeClass) {
      const goodResults = ['success', 'positive', 'good', 'happy'];
      const badResults = ['bad', 'negative', 'dq', 'reject', 'angry'];

      if (goodResults.includes(outcomeClass)) {
        return { bg: '#4caf50', text: '#fff' };
      }
      if (badResults.includes(outcomeClass)) {
        return { bg: '#f87171', text: '#fff' };
      }
      return { bg: '#4a5568', text: '#fff' };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~dashboard/assets/scss/woot';

.report_container {
  display: grid;
  grid-template-columns: 1fr;
  min-height: calc(100vh - 194px);
  @include breakpoint(large up) {
    grid-template-columns: 1fr 200px;
  }
}

.report_heading {
  display: flex;
  justify-content: space-between;
}

.right_side {
  border-left: 1px solid var(--s-75);
  ul {
    list-style: none;
    li {
      display: flex;
      justify-content: space-between;
    }
  }
}

.data_list {
  list-style: none;
  li {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid var(--s-75);

    &:first-child {
      border-top: 1px solid var(--s-75);
    }
  }
}

.flex_between {
  display: flex;
  justify-content: space-between;
}

.border_y {
  border-top: 1px solid var(--s-75);
  border-bottom: 1px solid var(--s-75);
}

.campaign--loader {
  align-items: center;
  display: flex;
  font-size: var(--font-size-default);
  justify-content: center;
  padding: var(--space-big);
}
</style>

<style>
.callLogDetailModal {
  width: 68rem !important;
}
.callLogDetailModal .tabs {
  padding: 0;
}
</style>
